import { FormActionButton } from '@workwave-tidal/core/form'

import { useController } from '../../../hooks/useController'
import { useTexts } from '../hooks/useTexts'

import { form } from '../../formState'

export function Footer() {
  const { status: modalStatus, close } = useController()

  const texts = useTexts()

  const {
    meta: { submitting: formSubmitting, validating },
  } = form.useFormMeta()

  const disabled = validating || formSubmitting || modalStatus === 'submitting'

  return (
    <>
      <FormActionButton
        testId="change-password-modal-cancel-button"
        data-trackid="change-password-modal-cancel-button"
        onClick={close}
        size="medium"
        label={texts.cancel}
      />
      <FormActionButton
        testId="change-password-modal-confirm-button"
        data-trackid="change-password-modal-confirm-button"
        disabled={disabled}
        loading={disabled}
        variant="contained"
        type="submit"
        label={texts.changePassword}
      />
    </>
  )
}
